import styled from 'styled-components';
import { Icon } from '@hotelplan/components.common.icon';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { CardsSection } from 'components/domain/customizable-slider/CardsSection';

export const SimilarDestinationsSection = styled(CardsSection)<{
  isCards: boolean;
}>(({ isCards }) =>
  sx2CssThemeFn({
    position: 'relative',
    py: ['50px', 9],
    '.media-card-content': {
      color: 'white',
    },

    '.siblings-item-wrapper': {
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'column',
      height: '100%',
      '.siblings-title': {
        mt: isCards && '10px',
        mb: 0,
      },
      '&:focus-visible': {
        outline: 'none',
        '.siblings-item:before': {
          width: '100%',
          height: '100%',
          content: "''",
          outline: '5px solid',
          outlineOffset: '-5px',
          position: 'absolute',
          zIndex: 3,
          top: 0,
          left: 0,
          outlineColor: `redHover`,
        },
        img: {
          transform: 'scale(1.1)',
          transition: 'all 0.5s ease',
        },
      },
      '&:hover': {
        img: {
          transform: 'scale(1.1)',
          transition: 'all 0.5s ease',
        },
        '.siblings-title': {
          '.icon': {
            marginRight: 0,
            transition: 'all 0.5s ease',
          },
        },
      },
    },
  })
);

export const MobileListItems = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    'a:first-child': {
      mt: 0,
    },
    '.siblings-item-wrapper': {
      mt: 2,
    },
  })
);

export const ChevronIcon = styled(Icon).attrs({
  name: 'chevron-long-right',
  className: 'icon',
  size: 'lg',
  width: '24px',
  height: '24px',
})({});
